
export const DEFAULT_THEME = 'dark';
export const MAX_ITEMS_PER_PAGE = 20;
export const residentRoles = ['Owner', 'Tenant', 'Guest'];
export const noticeTypes = ['General', 'Maintenance', 'Event', 'Alert'];
export const paymentMethods = ['Credit Card', 'Debit Card', 'Net Banking', 'UPI', 'Cash'];
export const paymentStatuses = ['Pending', 'Completed', 'Failed', 'Refunded'];
export const currencySymbol = '₹';
export const residentStatuses = ['Active', 'Inactive', 'Evicted', 'Pending'];
export const maintenanceCategories = ['Plumbing', 'Electrical', 'Cleaning', 'Security', 'Other'];   
export const months = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];
export const ExpenseCategories = ['Electricity','Water Bill','Security Salary','Housekeeping','Lift Maintenance','Garden Maintenance','Cleaning','Plumbing','Electrical Repair','Generator','Office Expense','Stationery','Internet','Festival','Event','Legal','AMC','Property Tax','Miscellaneous'];
export const PaymentModes = ['Cash','Cheque','UPI','Bank Transfer','Card'];
export const PaymentStatus = ['Pending','Paid','Failed','Refunded'];

 
export const API_BASE_URL = 'http://apexenterprise.shop/api';
export const API_BASE_URL2 = 'http://swara.apexenterprise.shop/api';

/* Notices API Endpoint*/
export const NoticesGetAPIEndpoint = '/notice/get_notices.php';  // Working with JWT
export const NoticesAddAPIEndpoint = '/notice/add_notice.php'; // Working with JWT
export const NoticesUpdateAPIEndpoint = '/notice/update_notice.php'; // Working with JWT
export const NoticesDeleteAPIEndpoint = '/notice/delete_notice.php'; /*/API not exists yet, but will be implemented in future.*/

/* Resdident API Endpoint*/
export const ResidentGetAPIEndpoint = '/resident/get_residents.php';  // Working with JWT
export const ResidentAddAPIEndpoint = '/resident/add_resident.php'; // Working with JWT
export const ResidentUpdateAPIEndpoint = '/resident/update_resident.php';// Working with JWT
export const ResidentDeleteAPIEndpoint = '/resident/delete_resident.php';// Working with JWT
export const ResidentCountGetAPIEndpoint = '/resident/get_resident_count.php'; // Working with JWT

/* Payments API Endpoint*/
export const PaymentsGetAPIEndpoint = '/payments/get_payment.php';
export const PaymentsAddAPIEndpoint = '/payments/add_payment.php';
export const PaymentsUpdateAPIEndpoint  = '/payments/update_payment.php';
export const PaymentsDeleteAPIEndpoint = '/payments/delete_payment.php';


/* Common Areas API Endpoint*/
export const CommonAreasGetAPIEndpoint = '/commonareas/get-common-areas.php';
export const CommonAreasUpdateAPIEndpoint = '/commonareas/update-common-areas.php';

/* Booking API Endpoint */
export const BookingAddAPIEndpoint = "/booking/add_booking.php";
export const BookingGetStatusBookingsAPIEndpoint = "/booking/get_status_bookings.php";
export const BookingUpdateAPIEndpoint = "/booking/Update_booking.php";
export const BookingapproveBookingEndpoint = "/booking/approve_booking.php";

/* User API EndPoint */
export const UserGetAPIEndPoint = "/users/get_user.php"; // NOT required as first request / login request
export const UsersGetAPIEndPoint = "/users/get_users.php";
export const ForgotPasswordAPIEndpoint = "/users/forgot_password.php";
export const VerifyForgotOtpAPIEndpoint = "/users/verify_forgot_otp.php";
export const ResetPasswordAPIEndpoint = "/users/reset-password.php";



/* Payment API EndPoint */
export const PaymentAddAPIEndPoint = "/payment/add_payment.php";


/* Complaint API EndPoint */
export const ComplaintAddAPIEndpoint = "/complaint/add_complaint.php";
export const ComplaintGetAPIEndpoint = "/complaint/get_complaints.php";
export const ComplaintStatusUpdateAPIEndpoint = "/complaint/update_complaint_status.php";

/* Expense API EndPoint */ 
export const ExpenseAddAPIEndpoint = "/expense/add_expense.php";
export const ExpenseGetAPIEndpoint = "/expense/get_expenses.php";
export const ExpenseUpdateAPIEndpoint = "/expense/update_expense.php";
export const ExpenseDeleteAPIEndpoint = "/expense/delete_expense.php";
export const ExpenseMonthlyAmountAPIEndpoint = "/expense/get_MonthlyAmount.php";


export const ExpenseFileUploadAPIURL = "http://apexenterprise.shop/api/uploads/";

